module.exports = __webpack_public_path__ + "static/media/onoiwa-extra-2.a9a69cf3.png";